<template>
  <ax-dialog 
    ref="dialog"
    title="Fix Wells" 
    subtitle="Automtically fix poorly declined wells"
    icon="tools" 
    tooltip="Fix Wells" 
    size="small" 
    @submitted="onSubmit"
  >
    <template slot="content">
      <v-card-text>
        <p>This method tries to automatically fix all poorly declined wells using <a href="https://docs.scipy.org/doc/scipy/reference/generated/scipy.optimize.curve_fit.html" target="_blank">non-linear least squares</a>.</p>
        <v-autocomplete v-model="selected" :items="options" clearable label="Limit decline method" :hint="selected ? `Only use the ${selected} function to decline` : 'Do not limit to any particular decline method'"/>
      </v-card-text>
    </template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
export default {
  name: "dlgFixWells",
  props: {
    wells: { type: Array, required: true }
  },
  components: {
    AxDialog
  },
  data() {
    return {
      selected: null,
      options: [
        { text: 'Exponential', value: 'exponential' },
        { text: 'Hyperbolic', value: 'hyperbolic' },
        { text: 'Harmonic', value: 'harmonic' },
      ]
    }
  },
  methods: {
    onSubmit() {
      this.$refs.dialog.show = false
      this.$emit('submitted', this.wells)
    }
  }
}
</script>